import * as React from "react";
import { useEffect } from "react";
import * as microsoftTeams from "@microsoft/teams-js";

const SignInSimpleEnd: React.FunctionComponent = () => {

    // Parse hash parameters into key-value pairs
    function getHashParameters() {
        const hashParams: any = {};
        window.location.hash.substr(1).split("&").forEach(function (item) {
            let source = item.split("="),
                key = source[0],
                value = source[1] && decodeURIComponent(source[1]);
            hashParams[key] = value;
        });
        return hashParams;
    }

    useEffect(() => {
        microsoftTeams.initialize();
        const hashParams: any = getHashParameters();

        console.log("SignInSimpleEnd hashParams : " + hashParams);

        if (hashParams["error"]) {
            // Authentication/authorization failed
            microsoftTeams.authentication.notifyFailure(hashParams["error"]);

        } else if (hashParams["access_token"]) {
            // Success
            let key = "simple.result";

            localStorage.setItem(key, JSON.stringify({
                idToken: hashParams["id_token"],
                accessToken: hashParams["access_token"],
                tokenType: hashParams["token_type"],
                expiresIn: hashParams["expires_in"]
            }));

            setTimeout(() => microsoftTeams.authentication.notifySuccess(key), 2000);

        } else {
            // Unexpected condition: hash does not contain error or access_token parameter
            microsoftTeams.authentication.notifyFailure("UnexpectedFailure");
        }
    });

    return (<></>)
};

export default SignInSimpleEnd;